/**
 * Boba stickers — authored via the `/pack` toile process (plan
 * `thinking/plans/2026_08_31_toile_pack_wiring.md` Track B), wave `toile_stickers`. Narcis file-split
 * shape (Track A): one module per pack, `registry.ts` assembles them into `livePacks`.
 */
import {tagline, chips, type ToilePack} from './data'

export const bobaStickersPack: ToilePack = {
    slug: 'boba-stickers',
    category: 'sticker',
    name: 'Boba stickers',
    tagline: tagline('pieces', 'themes', 'styles'),
    chips: chips('themes', 'styles'),
    ratio: {w: 1024, h: 1024},
    readings: [
        {key: 'classic', label: 'Milk tea', subject: 'a cup of brown milk tea with pearls and a wide straw, a smiling face'},
        {key: 'strawberry', label: 'Strawberry boba', subject: 'a pink strawberry boba with a cream top and a face'},
        {key: 'matcha', label: 'Matcha boba', subject: 'a green matcha boba with pearls and a sleepy face'},
    ],
    styles: [
        {key: 'kawaii', label: 'Kawaii', style: 'kawaii sticker illustration, rounded shapes, tiny smiling faces, soft thick outlines', palette: 'Pastel pink, mint, lilac and cream with dark outlines', framing: 'Each sticker isolated with a thick white die-cut border on a plain ground'},
        {key: 'bold', label: 'Bold cartoon', style: 'bold cartoon sticker, thick black outlines, bright flat fills, slight gloss', palette: 'Bright saturated primaries with black outlines', framing: 'Each sticker isolated with a thick white die-cut border on a plain ground'},
        {key: 'doodle', label: 'Hand-drawn', style: 'hand-drawn marker doodle sticker, loose line, flat wash fills', palette: 'Two or three muted colours with a black line', framing: 'Each sticker isolated with a thin white die-cut border on a plain ground'},
    ],
    directions: ['an iced coffee instead', 'for a water bottle', 'with extra pearls'],
    directionHint: 'try: an iced coffee instead',
    seo: {
        title: 'Boba Stickers: Milk Tea, Strawberry, Matcha',
        metaDescription: 'Nine boba stickers — classic milk tea, strawberry boba, matcha boba, each with a smiling face — in kawaii, bold cartoon, and hand-drawn styles.',
        h1: 'Boba stickers: milk tea, strawberry, matcha',
        tagline: 'Nine stickers, three boba flavours, three styles each.',
        intro: 'A cup of brown milk tea with pearls, a pink strawberry boba with a cream top, and a green matcha boba with a sleepy face — three boba stickers, die-cut and ready to print. Each rendered kawaii, bold cartoon, and loose hand-drawn. Ask for a different flavour, a boba shop scene, or a two-cup composition, and the same three styles carry it.',
        useCases: [
            'a water bottle or laptop lid',
            'a planner or journal page',
            'a phone case sticker sheet',
            'a boba shop or menu design',
        ],
        faq: [
            {q: "What's in this pack?", a: 'Nine boba stickers — classic milk tea, strawberry boba, and matcha boba, each with a small face — in kawaii, bold cartoon, and hand-drawn finishes.'},
            {q: 'Can I get a different boba flavour?', a: 'Yes — the direction field takes any variation, including a different flavour, a boba shop scene, or a two-cup composition.'},
            {q: 'What size should I print these at?', a: 'Each sticker is a square die-cut design, so it scales cleanly from a small vinyl sticker to a full A4 sheet.'},
            {q: 'Are these photos of real drinks?', a: 'No — every sticker is an original kawaii-style illustration, not a photograph.'},
        ],
    },
}
